import { render } from "./SetGoals.vue?vue&type=template&id=0a617bcb&scoped=true"
import script from "./SetGoals.vue?vue&type=script&lang=js"
export * from "./SetGoals.vue?vue&type=script&lang=js"

import "./SetGoals.vue?vue&type=style&index=0&id=0a617bcb&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a617bcb"]])

export default __exports__